import _ from 'lodash'
import Backbone from 'backbone'
import template from './scoreboard-db-step1.hbs'
import formHelper from 'scoreboard/components/form-helper'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import FormView from 'scoreboard/components/form-view'

var ScoreboardDbStep1 = Backbone.View.extend({

	// this.model is a Database

	tagName: 'form',

	initialize: function(options) {
		this.options = options || {}
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
		// #31826 keep track of the actual product so we can refer to it later
		this.initialDbProduct = this.model.get('product')
	},

	render: function() {
		this.$el.empty().append(template(this.model.attributes))

		this._toggle = new LabeledToggle({
			name: 'product',
			options: [{
				value: 'mysql',
				label: 'admin.databaseConnections.type.mysql'
			}, {
				value: 'sqlserver',
				label: 'admin.databaseConnections.type.sqlserver'
			}]
		})

		// we need the user to click on Next so we can send out a request and
		// validate the database connection
		this.options.wizard.lastNavigable = 1
		this.options.wizard.render({
			stateSaver: this.saveState.bind(this),
			formView: this.formView
		})

		this.$('.toggle-container').append(this._toggle.el)
		this._toggle.render()

		if (this.initialDbProduct === 'mariadb') {
			// #31826 MariaDB databases use all the same settings as MySQL, so we
			// just pretend we are using MySQL
			this.model.set('product', 'mysql')
		}
		formHelper.writeToDom(this.model, this.el)
		this._labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()
		this.formView.start()
		return this
	},

	saveState: function() {
		this.model.set(formHelper.readFromDom(this.el))
		if (this.model.get('product') === 'mysql' && this.initialDbProduct) {
			// #31826 change the database type back so the backend works correctly
			this.model.set('product', this.initialDbProduct)
		}
		// issue #10176 default mysql host to localhost
		if (!this.model.get('host') && this.model.get('product') === 'mysql') {
			this.model.set('host', 'localhost')
		}
	},

	submit: function(e) {
		this.saveState()
		this.options.wizard.next()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._labelField, this._toggle, this.wizardProgress, this.formView], 'remove')
	}

})

export default ScoreboardDbStep1

ScoreboardDbStep1.__filename__ = 'admin/connections/scoreboard-db-step1.js'
